/**
 * Format an event's `start_time` (typically "HH:MM:SS" from the DB) into
 * "h:MMam/pm" form (e.g., "9:30am") — lowercase am/pm with no space, for
 * tighter visual scanning. Returns empty string when input is missing/empty,
 * and returns the input unchanged if it doesn't match the expected pattern.
 */
export function formatEventTime(time: string | null | undefined): string {
  if (!time) return "";
  const trimmed = time.trim();
  if (!trimmed) return "";
  const match = trimmed.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return trimmed;
  let hour = parseInt(match[1], 10);
  const minute = match[2];
  if (Number.isNaN(hour)) return trimmed;
  const period = hour >= 12 ? "pm" : "am";
  hour = hour % 12 || 12;
  return `${hour}:${minute}${period}`;
}
